import $ from 'jquery';

class FAQSection {
	constructor(el) {
		if (el) {
			this.el = el;
			this.parent = this.el.parentElement;
			this.question = this.el.querySelector('.schema-faq-question');
			this.answer = this.el.querySelector('.schema-faq-answer');

			if (this.question && this.answer) {
				this.handleQuestionClick = this.handleQuestionClick.bind(this);
				this.question.addEventListener('click', this.handleQuestionClick);
			}
		}
	}

	handleQuestionClick() {
		$(this.answer).slideToggle();
		$(this.el).toggleClass('schema-faq-section--open');
	}
}

const faqSections = document.querySelectorAll('.schema-faq-section');
if (faqSections.length) {
	const FAQSections = [];
	faqSections.forEach((faqSection) => {
		FAQSections.push(new FAQSection(faqSection));
	});
}
